export const ROLES_TYPES = {
    MANAGER: 'manager',
    OPS_MANAGER: 'ops_manager',
  };
  